<script lang="ts">
	import VerivoxSetupBanner from './internal/VerivoxSetupBanner.svelte';
	import type { VerivoxDismissSurface } from '../utils/verivoxDismissals';

	/** Verivox setup promo for GlobalInlineBanners rail (~120px). */
	export let onCtaClick: () => void;
	export let dismissable = false;
	export let dismissSurface: VerivoxDismissSurface = 'roomsList';
	export let onDismiss: (() => void) | undefined;
</script>

<VerivoxSetupBanner layout="inline" {onCtaClick} {dismissable} {dismissSurface} {onDismiss} />
